<div
  [ngClass]="['list-group gap-2', direction === 'horizontal' ? 'list-group-horizontal' : '']"
  role="radiogroup"
  [attr.aria-disabled]="disabled"
>
  @for (option of optionList; track $index) {
    <button
      type="button"
      class="list-group-item list-group-item-action vertical-align-top border border-2 rounded-3"
      [class.selected]="option.value === selectedValue"
      aria-current="true"
      (click)="onRadioSelected(option.value)"
      [disabled]="disabled"
    >
      <ng-container *ngTemplateOutlet="option.templateRef"></ng-container>
    </button>
  }
</div>
